import { ChevronRight, ShoppingBag } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { NavLink } from "react-router-dom";
import { useAuthStore } from "../../features/auth/store";
import { getFollowingUsers } from "../../entities/user/api";
import { IS_API_MODE } from "../../shared/config/runtime";
import { stories } from "../../shared/data/mockData";
import defaultAvatar from "../../shared/ui/defaultAvatar";

export default function RightRail({ posts = [], followingUsers = [] }) {
  const user = useAuthStore((state) => state.user);
  const followingQuery = useQuery({
    queryKey: ["users", user?.id, "following"],
    queryFn: () => getFollowingUsers(user.id),
    enabled: IS_API_MODE && Boolean(user?.id),
    staleTime: 60_000,
  });
  const postSuggestions = IS_API_MODE
    ? posts.filter((post) => post.authorId && String(post.authorId) !== String(user?.id))
        .reduce((items, post) => items.some((item) => item.id === String(post.authorId)) ? items : [...items, { id: String(post.authorId), name: post.author, username: post.username, avatar: post.avatar }], [])
        .slice(0, 3)
    : [];
  const fallbackUsers = followingUsers.length ? followingUsers : (followingQuery.data?.results || followingQuery.data || []);
  const suggestions = IS_API_MODE
    ? (postSuggestions.length ? postSuggestions : fallbackUsers.slice(0, 3).map((item) => ({
        id: String(item.id),
        name: item.nickname || item.username,
        username: item.username,
        avatar: item.avatar_url || item.avatarUrl || defaultAvatar,
      })))
    : stories.slice(3, 6);
  return (
    <aside className="right-rail">
      <div className="suggestion-heading">
        <strong>为你推荐</strong>
        <button>查看全部</button>
      </div>
      {!suggestions.length ? <div className="rail-state">暂无推荐用户</div> : null}
      {suggestions.map((item, index) => {
        const story = item;
        return (
        <div className="suggestion" key={story.id}>
          <NavLink to={`/users/${story.id}`}><img className="avatar avatar-sm" src={story.avatar} alt="" /></NavLink>
          <span>
            <strong>{story.name}</strong>
            <small>{IS_API_MODE ? `@${story.username}` : index === 0 ? "你可能认识" : "热门平面设计师"}</small>
          </span>
          <NavLink className="suggestion-link" to={`/users/${story.id}`}>查看</NavLink>
        </div>
        );
      })}
      <div className="rail-card">
        <div className="rail-card-icon">
          <ShoppingBag size={20} />
        </div>
        <div>
          <strong>把灵感变成合作</strong>
          <p>发布设计需求，与社区里的设计师安全合作。</p>
          <NavLink to="/orders/new">创建快单 <ChevronRight size={14} /></NavLink>
        </div>
      </div>
      <footer className="rail-footer">关于 · 帮助 · 隐私 · 条款 · 图π © 2026</footer>
    </aside>
  );
}
